export const enum PlatformType {
    WHATSAPP = "whatsapp",
    SMS = "sms",
    TEST = "test",
    MESSENGER = "messenger",
    WEB = "web",
    EMAIL = "email",
    INSTAGRAM = "instagram",
    BUSINESS_MESSAGES = "business_messages",
    DIRECT_MESSAGES = "direct_messages",
    TELEGRAM = "telegram",
}
